import { ErrorSchema } from '@rjsf/utils';

// SchemaForm's `errors` are keyed by field. A dotted key ("endpoints.0.url") is a
// field inside a list row or nested object, which the uiSchema cannot address
// per row, so it goes to rjsf as an error schema and shows under that row's field.
export function nestedErrorSchema(
  errors: Record<string, string> | null | undefined,
): ErrorSchema | undefined {
  const entries = Object.entries(errors ?? {}).filter(([key]) =>
    key.includes('.'),
  );
  if (!entries.length) return undefined;
  const root: any = {};
  entries.forEach(([key, message]) => {
    const node = key
      .split('.')
      .reduce((parent: any, segment) => (parent[segment] ??= {}), root);
    node.__errors = [...(node.__errors ?? []), message];
  });
  return root;
}
